<template>
  <div>
    <div class="mx-2 pt-2 py-2">
      <h1 class="flex justify-center text-2xl 100vh mb-5 pt-10">Update User</h1>
      <form class="max-w-md mx-auto" @submit.prevent="submit">
        <div class="mb-5">
          <label
            for="text"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            User Name</label
          >
          <input
            type="text"
            v-model="form.username"
            id="username"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="User"
          />
        </div>
        <div class="mb-5">
          <label
            for="text"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Display Name</label
          >
          <input
            type="text"
            v-model="form.display_name"
            id="displayname"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="Display Name"
          />
        </div>
        <div class="mb-5">
          <label
            for="countries"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Select Working Hospital</label
          >
          <select
            id="hospitals"
            ref="staffHospital"
            multiple
            v-model="hospital_id"
            style="height: 40px; background: white"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value=""></option>
            <option
              v-for="hospital in selectSites"
              :key="hospital.id"
              :value="hospital.id"
            >
              {{ hospital.name }}
            </option>
          </select>
        </div>
        <div class="mb-5" v-if="hascanassignroletouser">
          <label
            for="countries"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Select Roles</label
          >
          <select
            id="countries"
            v-model="form.role_id"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option selected>Choose a Role</option>
            <option v-for="rol in role" :key="rol.id" :value="rol.id">
              {{ rol.name }}
            </option>
          </select>
        </div>
        <div class="mb-5" v-if="hasCanSignSiteToUser">
          <div class="flex justify-between">
            <span>
              <label
                for="countries"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Other Hospitals</label
              ></span
            >
            <div class="flex items-center mb-4">
              <input
                id="default-checkbox"
                v-model="allHospital"
                type="checkbox"
                value=""
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                for="default-checkbox"
                class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                {{ allHospital ? "Unselect all " : "Select all " }}
              </label>
            </div>
          </div>
          <select
            v-model="sites"
            ref="hospitalsSelect2s"
            multiple="multiple"
            id="hospitalsSelect2"
            style="height: 40px"
            class="js-example-disabled-results bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value=""></option>
            <option v-for="site in selectSites" :key="site.id" :value="site.id">
              {{ site.name }}
            </option>
          </select>
        </div>
        <div class="mb-5">
          <label
            for="email"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Email</label
          >
          <input
            type="email"
            id="email"
            v-model="form.email"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="name@flowbite.com"
          />
        </div>
        <div class="flex items-center justify-center">
          <router-link
            to="user"
            class="text-white mb-5 bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Back</router-link
          >
          <button
            type="submit"
            class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Update User
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  computed,
  onMounted,
  watchEffect,
  onUnmounted,
  onUpdated,
  onBeforeMount,
} from "vue";
import axiosInstce from "@/plugins/axios";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import $ from "jquery";
import "select2";
// import Multiselect from "@vueform/multiselect";
const router = useRouter(); // Initialize the router object
const form = ref({
  email: "",
  username: "",
  display_name: "",
  role_id: "",
  working_site_id: "",
  // hospital_id: '',
  // sites:null,
});
const sites = ref([]);
const working_site_id = ref([]);
const selectHospitals = ref([]);
const selectSites = ref([]);
const allHospital = ref(false);
const checkbox = ref(false);
const role = ref();
const userId = ref();
const change_hospital = ref([]);
const hospital_id = ref([1]);
const getusers = (id) => {
  axiosInstce
    .get(`/user/${id}`)
    .then((response) => {
      form.value = {
        email: response.data.data.user?.email,
        username: response.data.data.user?.username,
        display_name: response.data.data?.user.display_name,
        role_id: response.data.data.user?.roles[0]?.id,
        working_site_id: response.data.data.user.working_hospital?.id,
      };
      hospital_id.value = Array.isArray(response.data.data?.user?.hospital_id)
        ? response.data.data?.user?.hospital_id
        : [response.data.data?.user?.hospital_id];
      allHospital.value = response.data.data.user.all_hospitals_selected;
      checkbox.value = response.data.data.user.all_hospitals_selected;
      sites.value = response.data.data.user.hospitals.map((site) => site.id);
      console.log(
        response.data.data.user.hospitals.map((site) => site.id),
        "sites valllllllll"
      );
      console.log($("#hospitalsSelect2").val(), "check val");
    })
    .catch((error) => {
      console.error("user fetch:", error);
    });
};

const roles = () => {
  axiosInstce
    .get(`/roles`)
    .then((response) => {
      role.value = response.data.data.roles;
    })
    .catch((error) => {
      console.error("Error fetching sites:", error);
    });
};
const getHospitals = () => {
  const hospitalId = 100000000;
  axiosInstce
    .get(`/all-hospitals`)
    .then((response) => {
      const hospital = response.data.data;
      const districtNames = hospital.map((hospitals) => hospitals);
      selectSites.value = districtNames;
      selectHospitals.value = districtNames;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};

const submit = async () => {

  try {
    const selectedHospitals = $("#hospitals").val();
    // console.log($("#hospitals").val(),'>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    if (selectedHospitals && selectedHospitals.length > 1) {
      // Show a warning message
      Swal.fire({
        title: "Warning",
        text: "Please select only one working hospital.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // Stop further execution
    }
    const response = await axiosInstce.put(`/users/${userId.value}`, {
      username: form.value.username,
      display_name: form.value.display_name,
      email: form.value.email,
      role_id: form.value.role_id,
      hospital_id: selectedHospitals[0] ||1 ,
      // working_site_id: selectedHospitals[0],
      other_site_ids: $("#hospitalsSelect2").val(),
      all_hospitals_selected: allHospital.value ? 1 : 0,
    });

    Swal.fire({
      toast: true,
      title: "User updated successfully.",
      icon: "success",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
    router.push({ name: "user" });
  } catch (error) {
    console.error("Error fetching district info:", error);
    Swal.fire({
      toast: true,
      title: error.response.data.message,
      icon: "error",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }
};
watch(allHospital, (newAllHospitalValue, oldAllHospitalValue) => {
  if (newAllHospitalValue === true) {
    // alert("All hospitals selected");
    $("#hospitalsSelect2")
      .val(selectSites.value.map((site) => site.id))
      .trigger("change");
    // Wait for 500 milliseconds (half a second)
    setTimeout(() => {
      if (checkbox.value) {
        sites.value = selectSites.value.map((site) => site.id);
      }
      if (!checkbox.value) {
        sites.value = selectSites.value.map((site) => site.id);
      }
    }, 500);
  } else {
    if ($("#hospitalsSelect2").val().length === selectSites.value.length) {
      // alert("All hospitals deselected");
      $("#hospitalsSelect2").val([]).trigger("change");
      sites.value = [];
    } else {
      // No change needed
    }
  }
});


onMounted(async () => {
  const id = router.currentRoute.value.params.id;
  userId.value = id;
  try {
    await Promise.all([getusers(id), getHospitals()]);
    roles();
  } catch (error) {
    console.error("Error during initialization:", error);
  }
});

const hospitalsSelect2s = ref(null);
onMounted(() => {
  $(document).ready(function () {
    $("#hospitalsSelect2").select2({
      placeholder: " Other Hospitals",
      allowClear: true,
    });
    // Initialize Select2 for Select 1
    $("#hospitals").select2({
      placeholder: "Select Hospital",
      allowClear: true,
    });
  });
  watchEffect(() => {
    if (hospitalsSelect2s.value) {
      $(hospitalsSelect2s.value).select2();
      $(hospitalsSelect2s.value).on("change", () => {
        change_hospital.value = $("#hospitalsSelect2").val();
        // Check if the length of selected hospitals is equal to the length of all hospitals
        if (change_hospital.value.length !== selectSites.value.length) {
          allHospital.value = false;
        }
        if (change_hospital.value.length === selectSites.value.length) {
          allHospital.value = true;
        }
      });
    }
  });
});

import { useAuthService } from "@/store/Auth"; //  auth.js file
const authStore = useAuthService();
const permissions = ref([]);
onMounted(() => {
  const authData = authStore.authData;
  permissions.value = authStore.authData.permissions;
});
const hasCanSignSiteToUser = computed(() =>
  permissions.value.some(
    (permission) => permission.name === "can assign site to user"
  )
);
const hascanassignroletouser = computed(() =>
  permissions.value.some(
    (permission) => permission.name === "can assign role to user"
  )
);

onMounted(async () => {
  await authStore.handlepermission();
});

onUnmounted(async () => {
  await authStore.handlepermission();
});
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
